import { BaseSubjectStore } from '@procom-labs/common'

import { IRemainingUsage, IServicePlan, IUserOrganization } from '../models'

export interface UserOrganizationStoreState {
  userOrganization: IUserOrganization | null
  remainingUsage: IRemainingUsage | null
  isPendingJoin: boolean | null
  userOrgAccessType: string | null
  canAccessSettings: boolean | null
  hasServicePlan: boolean | null
  servicePlan: IServicePlan | null
  teamManagementEnabled: boolean | null
  isOrgFull: boolean | null
}

export class UserOrganizationStore extends BaseSubjectStore<UserOrganizationStoreState> {
  getDefaultValue(): UserOrganizationStoreState {
    return {
      userOrganization: null,
      remainingUsage: null,
      isPendingJoin: null,
      userOrgAccessType: null,
      canAccessSettings: null,
      hasServicePlan: null,
      servicePlan: null,
      teamManagementEnabled: null,
      isOrgFull: null,
    }
  }
}

export const userOrganizationStore = new UserOrganizationStore()
